import React from "react";
import ReactDOM from "react-dom/client";
import Approuter from "./Routes/Approuter";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/css/line-awesome.min.css";
import "./assets/scss/main.scss";
import "./assets/css/material.css";
import { ToastContainer } from 'react-toastify';

import { AuthProvider } from 'context/userContext';
import store from "store/store";
import { Provider } from "react-redux";

// Check if we're in production based on the API URL
const isProduction = process.env.REACT_APP_API_URL === "https://api.nandosess.ae"  && !window.location.hostname.includes("localhost");

// Disable console logs in production
if (isProduction) {
  const noop = () => {};
  // Save original console methods (optional)
  const originalConsole = {
    log: console.log,
    warn: console.warn,
    info: console.info,
    debug: console.debug
  };
  
  // Replace console methods with no-op function in production
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
  
  // Keep error logging for production issues
  // console.error remains unchanged
}

const root = ReactDOM.createRoot(document.getElementById("root"));

if (module.hot) {
  module.hot.accept()
}

root.render(
  <Provider store={store}>
    <AuthProvider>
      <Approuter />
      <ToastContainer />
    </AuthProvider>
  </Provider>
);
